var _rect, _path, _circle, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseIcon = function SvgPauseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FDF6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1429 35.7333V32H48.8571V35.7333H71.1429V32H74.8571V35.7333H76.7143C81.8426 35.7333 86 39.912 86 45.0667V78.6667C86 83.8213 81.8426 88 76.7143 88H43.2857C38.1574 88 34 83.8213 34 78.6667V45.0667C34 39.912 38.1574 35.7333 43.2857 35.7333H45.1429ZM45.1429 43.2V39.4667H43.2857C40.2087 39.4667 37.7143 41.9739 37.7143 45.0667V46.9333H82.2857V45.0667C82.2857 41.9739 79.7913 39.4667 76.7143 39.4667H74.8571V43.2H71.1429V39.4667H48.8571V43.2H45.1429ZM37.7143 50.6667V78.6667C37.7143 81.7595 40.2087 84.2667 43.2857 84.2667H76.7143C79.7913 84.2667 82.2857 81.7595 82.2857 78.6667V50.6667H37.7143Z",
    fill: "#F1B752"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 20,
    fill: "#F1B752",
    stroke: "#FDF6E9",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 71,
    width: 4,
    height: 14,
    rx: 2,
    fill: "#FFF5E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 71,
    width: 4,
    height: 14,
    rx: 2,
    fill: "#FFF5E5"
  })));
};
export { SvgPauseIcon as ReactComponent };